goog.provide("shadow.js.shim.module$jszip");
goog.provide("module$shadow_js_shim_module$jszip");
shadow.js.shim.module$jszip = shadow.js.nativeProvides["jszip"] = shadow$bridge("jszip");
module$shadow_js_shim_module$jszip.default = shadow.js.shim.module$jszip;
